export default {
      id: "icon-info-red-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "./images/svg/symbols.svg#icon-info-red",
      toString: function () {
        return this.url;
      }
    }